// import libraries
import React from 'react';
// import screens
import { Chat as PrivateChat } from '../../private/Chat/Index';
// import constants (required by architecture guide, even if unused)
// constant.js contains application-wide constants, to be used across components
import './constant';

function Chat(props) {
  return (
    <PrivateChat {...props} />
  );
}

export { Chat };
export default Chat;